import React, { useState, useEffect } from "react";
import { isEmpty } from "../libs/isEmpty";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import DeleteIcon from '@material-ui/icons/Delete';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ModalButton from './ModalButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import { Grid } from "@material-ui/core";
import showSpatialFilter from "./showSpatialFilter";
import { trimString } from "../libs/trimString";
import Button from '@material-ui/core/Button';
import FileUpload from './FileUpload';
import { useCardStyles } from '../styles/commonStyles';



export default function DokumentList({
  ...props
}) {
  const classes = useCardStyles();
  const [isVendorless, setIsVendorless] = useState(true);
  const [hasFile, setHasFile] = useState(false);
  const [docId, setDocId] = useState('');

  useEffect(() => {
    if (isEmpty(props.vendorMeta)) {
      setIsVendorless(true)
    } else {
      setIsVendorless(false)
    }
  }, [props.vendorMeta])

  useEffect(() => {
    if (isEmpty(props.vendorMeta)) {
      
    } else {
      setIsVendorless(false)
    }
  }, [docId])

  const rows = props.docs

  function setDoc(doc_id){
    //console.log(doc_id)
    props.set(doc_id)
  }

  //console.log(rows)
  //console.log(props)
  return (
    <Card
      className={classes.root}
      raised
    >
      <CardHeader title="Dokument liste" />
      <CardContent>
          {isVendorless ? (
            <>
            <ListItem className={classes.listitem} key={"addDatasource"}>
              <ListItemText>
               Der er ikke valgt en profil.
              </ ListItemText>
            </ListItem>        
            </>
          ) : (
            <>
            <Table size="small" className={classes.table} aria-label="datasource-table">
              <TableHead>
                <TableRow>
                  <TableCell>Dokument</TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <TableRow key={row.doc_id}>
                    {row.active ? (
                      <>
                      <TableCell component="th" scope="row">{trimString(row.alias, 20)}</TableCell>
                      <TableCell align="center">{showSpatialFilter(row.geom)}</TableCell>
                      <TableCell align="center">
                      <Grid 
                        container
                        //style={{width: 166}}
                        direction="row"
                        alignItems="flex-start"
                        justifyContent="center">
                          <Grid item>
                            <Button
                            onClick={() => setDoc(row.doc_id)}>
                              <EditIcon />
                            </Button>
                          </Grid>
                          <Grid item>
                            <ModalButton
                              btnColor="default"
                              id={row.doc_id}
                              btnText={<DeleteIcon />}
                              acceptAction={() => {props.delete(row.doc_id)}}
                              acceptText="slet"
                              cancelText="fortryd"
                              titleText={"Bekræft sletning af dokumentet: " + row.alias}
                              contentText={"Denne handling fjerner dokumentet: '" + row.alias + "' tilhørende " + props.vendorMeta.vendor_alias + " uden yderligere varsel. Dokumentet vil ikke længere blive vedhæftet graveforespørglerne."}
                            />         
                          </Grid>
                        </Grid>
                      </TableCell>
                      </>
                    ) : (
                      <>
                      <TableCell className={classes.notactive} component="th" scope="row">{trimString(row.alias, 25)}</TableCell>
                      <TableCell className={classes.notactive} align="center">{showSpatialFilter(row.geom)}</TableCell>
                      <TableCell className={classes.notactive} align="center">
                      <Grid 
                        container
                        //style={{width: 166}}
                        direction="row"
                        alignItems="flex-start"
                        justifyContent="center">
                          <Grid item>
                            <Button
                            onClick={() => setDoc(row.doc_id)}>
                              <EditIcon />
                            </Button>
                          </Grid>
                          <Grid item>
                            <ModalButton
                              btnColor="default"
                              id={row.doc_id}
                              btnText={<DeleteIcon />}
                              acceptAction={() => {
                                props.set('')
                                props.delete(row.doc_id);
                              }}
                              acceptText="slet"
                              cancelText="fortryd"
                              titleText={"Bekræft sletning af dokumentet: " + row.alias}
                              contentText={"Denne handling fjerner dokumentet: '" + row.alias + "' tilhørende " + props.vendorMeta.vendor_alias + " uden yderligere varsel. Dokumentet vil ikke længere blive vedhæftet graveforespørglerne."}
                            />         
                          </Grid>
                        </Grid>
                      </TableCell>
                      </>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <FileUpload 
              hasFile={hasFile}
              setHasFile={setHasFile}
              accept={['application/msword','application/pdf','application/vnd.openxmlformats-officedocument.wordprocessingml.document']}
              onSuccess={(response, values) => {
                let createDoc = {
                  doc_id: response.data.doc_id,
                  vendor_id: props.vendorMeta.vendor_id,
                  alias: values.filename
                }
                props.create({body:createDoc});
              }}
              vendorMeta={props.vendorMeta}/>
            </>
          )}
      </CardContent>
    </Card>
  )
}
